import { observable, action, intercept, computed } from "mobx";
import { post } from "../services/ajax.service";

class AWPValidationStore {

  @observable awpDifference = 0;
  @observable awp_drug_count = 0;
  @observable drugs_by_awp = [];
  @observable filterValue = "";
  @observable url = "/api/v1/performaneactions/awpvalidation";
  @computed get tiles() {
    return parseInt(this.awp_drug_count / 100) > 0 ? parseInt(this.awp_drug_count / 100) + 1 : 0;
  }

  @action sortbydesc(filter) {
    this.filterValue = filter;
    if (this.drugs_by_awp.length > 0) {

      if (filter == "claim_id") {
        this.drugs_by_awp = this.drugs_by_awp.sort(function (a, b) {
          if (a.claim_id < b.claim_id) return -1;
          if (a.claim_id > b.claim_id) return 1;
          return 0
        })
      }
      if (filter == "label_name") {
        this.drugs_by_awp = this.drugs_by_awp.sort(function (a, b) {
          if (a.label_name < b.label_name) return -1;
          if (a.label_name > b.label_name) return 1;
          return 0
        })
      }

      if (filter == "total_cost") {
        this.drugs_by_awp = this.drugs_by_awp.sort(function (a, b) {
          if (parseInt(a.total_cost) < parseInt(b.total_cost)) return -1;
          if (parseInt(a.total_cost) > parseInt(b.total_cost)) return 1;
          return 0
        })
      }

      if (filter == "plan_pay") {
        this.drugs_by_awp = this.drugs_by_awp.sort(function (a, b) {
          if (parseInt(a.plan_pay) < parseInt(b.plan_pay)) return -1;
          if (parseInt(a.plan_pay) > parseInt(b.plan_pay)) return 1;
          return 0
        })
      }

      if (filter == "co_pay") {
        this.drugs_by_awp = this.drugs_by_awp.sort(function (a, b) {
          if (parseInt(a.co_pay) < parseInt(b.co_pay)) return -1;
          if (parseInt(a.co_pay) > parseInt(b.co_pay)) return 1;
          return 0
        })
      }

      if (filter == "client_awp") {
        this.drugs_by_awp = this.drugs_by_awp.sort(function (a, b) {
          if (parseInt(a.client_awp) < parseInt(b.client_awp)) return -1;
          if (parseInt(a.client_awp) > parseInt(b.client_awp)) return 1;
          return 0
        })
      }

      if (filter == "latest_awp") {
        this.drugs_by_awp = this.drugs_by_awp.sort(function (a, b) {
          if (parseInt(a.latest_awp) < parseInt(b.latest_awp)) return -1;
          if (parseInt(a.latest_awp) > parseInt(b.latest_awp)) return 1;
          return 0
        })
      }
      if (filter == "claim_type") {
        this.drugs_by_awp = this.drugs_by_awp.sort(function (a, b) {
          if (a.claim_type < b.claim_type) return -1;
          if (a.claim_type > b.claim_type) return 1;
          return 0
        })
      }
    }
  }
  @action sortbyasc(filter) {
    this.filterValue = filter;
    if (this.drugs_by_awp.length > 0) {

      if (filter == "claim_id") {
        this.drugs_by_awp = this.drugs_by_awp.sort(function (a, b) {
          if (a.claim_id > b.claim_id) return -1;
          if (a.claim_id < b.claim_id) return 1;
          return 0
        })
      }
      if (filter == "label_name") {
        this.drugs_by_awp = this.drugs_by_awp.sort(function (a, b) {
          if (a.label_name > b.label_name) return -1;
          if (a.label_name < b.label_name) return 1;
          return 0
        })
      }

      if (filter == "total_cost") {
        this.drugs_by_awp = this.drugs_by_awp.sort(function (a, b) {
          if (parseInt(a.total_cost) > parseInt(b.total_cost)) return -1;
          if (parseInt(a.total_cost) < parseInt(b.total_cost)) return 1;
          return 0
        })
      }

      if (filter == "plan_pay") {
        this.drugs_by_awp = this.drugs_by_awp.sort(function (a, b) {
          if (parseInt(a.plan_pay) > parseInt(b.plan_pay)) return -1;
          if (parseInt(a.plan_pay) < parseInt(b.plan_pay)) return 1;
          return 0
        })
      }

      if (filter == "co_pay") {
        this.drugs_by_awp = this.drugs_by_awp.sort(function (a, b) {
          if (parseInt(a.co_pay) > parseInt(b.co_pay)) return -1;
          if (parseInt(a.co_pay) < parseInt(b.co_pay)) return 1;
          return 0
        })
      }

      if (filter == "client_awp") {
        this.drugs_by_awp = this.drugs_by_awp.sort(function (a, b) {
          if (parseInt(a.client_awp) > parseInt(b.client_awp)) return -1;
          if (parseInt(a.client_awp) < parseInt(b.client_awp)) return 1;
          return 0
        })
      }

      if (filter == "latest_awp") {
        this.drugs_by_awp = this.drugs_by_awp.sort(function (a, b) {
          if (parseInt(a.latest_awp) > parseInt(b.latest_awp)) return -1;
          if (parseInt(a.latest_awp) < parseInt(b.latest_awp)) return 1;
          return 0
        })
      }
      if (filter == "claim_type") {
        this.drugs_by_awp = this.drugs_by_awp.sort(function (a, b) {
          if (a.claim_type > b.claim_type) return -1;
          if (a.claim_type < b.claim_type) return 1;
          return 0
        })
      }
    }
  }
  @action getAwpDifference = async (data) => {
    this.awpDifference = 0;
    try {
      let response = await post(
        `${this.url}/getAwpDifference`,
        data
      );

      this.awpDifference = response.data[0].awp_difference;
    } catch (err) {
      console.log(err);
    }
  }
  @action get_drugs_by_awp = async (data) => {
    this.drugs_by_awp = [];
    try {
      let response = await post(
        `${this.url}/get_drugs_by_awp`,
        data
      );

      this.drugs_by_awp = response.data;
    } catch (err) {
      console.log(err);
    }
  }
  @action get_drugs_by_awp_count = async (data) => {
    this.drugs_by_awp = [];
    try {
      let response = await post(
        `${this.url}/get_drugs_by_awp_count`,
        data
      );
      this.awp_drug_count = response.data[0]?.count;

    } catch (err) {
      console.log(err);
    }
  }


}

export default AWPValidationStore;
